import React, { useState } from 'react';
import { Home } from './pages/Home';
import { Rental } from './pages/Rental';
export function App() {
  const [page, setPage] = useState<'home' | 'rental'>('home');
  if (page === 'rental') {
    return <Rental onBack={() => setPage('home')} data-id="element-0" />;
  }
  return <Home onNavigate={setPage} data-id="element-1" />;
}